// frontend/src/services/api.js
import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:5000/api",
  timeout: 10000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

// Auth
export const login               = (username, password) => api.post("/auth/login", { username, password });

// Poles
export const fetchPoles          = ()         => api.get("/poles");
export const createPole          = (data)     => api.post("/poles", data);
export const updatePole          = (id, data) => api.put(`/poles/${id}`, data);
export const deletePole          = (id)       => api.delete(`/poles/${id}`);

// Pole Types
export const fetchPoleTypes      = ()         => api.get("/pole-types");
export const createPoleType      = (data)     => api.post("/pole-types", data);
export const updatePoleType      = (id, data) => api.put(`/pole-types/${id}`, data);
export const deletePoleType      = (id)       => api.delete(`/pole-types/${id}`);

// Proximity
export const logProximity        = (pole_id, latitude, longitude, distance_m) =>
  api.post("/proximity/log", { pole_id, latitude, longitude, distance_m });
export const fetchProximityLogs  = (pole_id, limit=50) =>
  api.get("/proximity/logs", { params: { pole_id, limit } });

// Users
export const fetchUsers          = ()         => api.get("/users");
export const createUser          = (data)     => api.post("/users", data);
export const updateUser          = (id, data) => api.put(`/users/${id}`, data);
export const deleteUser          = (id)       => api.delete(`/users/${id}`);
export const resetUserPassword   = (id, newPassword) => api.put(`/users/${id}/reset-password`, { newPassword });

// Roles
export const fetchRoles          = ()         => api.get("/roles");
export const fetchPermissions    = ()         => api.get("/roles/permissions");
export const createRole          = (data)     => api.post("/roles", data);
export const updateRole          = (id, data) => api.put(`/roles/${id}`, data);
export const deleteRole          = (id)       => api.delete(`/roles/${id}`);

// Groups
export const fetchGroups         = ()         => api.get("/groups");
export const createGroup         = (data)     => api.post("/groups", data);
export const updateGroup         = (id, data) => api.put(`/groups/${id}`, data);
export const deleteGroup         = (id)       => api.delete(`/groups/${id}`);
export const addGroupMember      = (gid, user_id)  => api.post(`/groups/${gid}/members`, { user_id });
export const removeGroupMember   = (gid, uid)      => api.delete(`/groups/${gid}/members/${uid}`);

export default api;
